import script from "./InvoicesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicesPage.vue?vue&type=script&setup=true&lang=js"

import "./InvoicesPage.vue?vue&type=style&index=0&id=80b57848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80b57848"]])

export default __exports__